var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLink({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.902 5.098a3.75 3.75 0 00-5.304 0l-3.134 3.135c-1.515 1.514-1.374 3.928 0 5.303.23.23.485.418.754.572l.572-.572c.375-.375.243-.814.236-1.13a1.822 1.822 0 01-.236-.196c-.705-.705-.737-1.915 0-2.652l3.134-3.134a1.877 1.877 0 012.652 0c.731.731.731 1.92 0 2.652l-2.072 2.072c.06.331.42 1.116.235 2.411.009-.008.02-.014.028-.023l3.135-3.134a3.75 3.75 0 000-5.304z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.779 10.22a3.569 3.569 0 00-.754-.572l-.572.572c-.375.376-.243.814-.236 1.13.082.06.162.122.236.196.705.706.737 1.915 0 2.652l-3.377 3.377a1.877 1.877 0 01-2.652 0 1.877 1.877 0 010-2.652L8.74 12.61c-.06-.332-.42-1.117-.235-2.412-.009.009-.02.014-.029.023l-3.377 3.377a3.75 3.75 0 005.304 5.304l3.377-3.377c1.486-1.487 1.405-3.898 0-5.303z"
  })));
}

export default SvgLink;